export default __webpack_public_path__ + "static/media/icon_image_delete.13bfd757.svg";